import { render, staticRenderFns } from "./fastPublication.vue?vue&type=template&id=189203e3&scoped=true"
import script from "./fastPublication.vue?vue&type=script&lang=js"
export * from "./fastPublication.vue?vue&type=script&lang=js"
import style0 from "./fastPublication.vue?vue&type=style&index=0&id=189203e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189203e3",
  null
  
)

export default component.exports